export default __webpack_public_path__ + "c7a21793ac6daada9ce78316e4e7e5ef.png";